import { Grid, Card, CardContent, Typography, Box, Button, Stack } from "@mui/material";
import { useSelector } from "react-redux";
import { useAuth } from "../../context/AuthContext";

export default function ClientDashboardHome() {

    const { data: organizations = [], loading, error } = useSelector((state) => state.organizations.organizations);
    const { user } = useAuth()
  

if (loading) return <Typography>Chargement...</Typography>;
if (error) return <Typography color="error">Erreur lors du chargement des données.</Typography>;
if (!organizations.length) return <Typography>Aucune organisation trouvée.</Typography>;

const org = organizations[0];

const services = [
    {
        label: "Antivirus ESET",
        value: org.esetLicenses?.length > 0 ? org.esetLicenses.length : 0,
    },
    {
        label: "Office 365",
        value: org.o365Licenses?.length > 0 ? org.o365Licenses.length : 0,
    },
    {
        label: "Sauvegarde O365",
        value: org.vbo365Licenses?.length > 0 ? org.vbo365Licenses.length : 0,
    },
];

return (
    <Box>
        <Box>
            <Typography variant="h5" my={2}>Bienvenue, {user.firstname} {user.lastname} </Typography>
        </Box>
        <Box>
            <Typography variant="h6" my={4}>Vos services</Typography>
        </Box>
        <Grid container spacing={2}>
            {services.map((service, idx) => (
                <Grid item size={{ xs: 12, md: 4, lg: 3 }} key={service.label}>
                    {service.value > 0 && (
                        <Card sx={{ minHeight: 120, display: "flex", flexDirection: "column", justifyContent: "center" }} borderRadius={2}>
                            <CardContent sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2 }}>
                                <Typography variant="h6" sx={{ mb: 2, textAlign: "center" }}>
                                    {service.label}
                                </Typography>
                                <span style={{ color: "green", marginTop: 8 }}>
                                    <svg width="36" height="36" fill="none" viewBox="0 0 24 24">
                                        <circle cx="12" cy="12" r="12" fill="#e8f5e9"/>
                                        <path d="M7 13l3 3 7-7" stroke="#43a047" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                </span>
                            </CardContent>
                        </Card>
                    )}
                </Grid>
            ))}

        </Grid>
        <Box>
            <Typography variant="h6" my={4}>Faire une demande</Typography>
            <Stack
                direction="row"
                spacing={2}        // espace horizontal entre les boutons
                flexWrap="wrap"    // permet de passer à la ligne
                useFlexGap         // gère bien l’espace vertical
                sx={{ mb: 2 }}
                >
                <Button variant="outlined">Onboarding Employé</Button>
                <Button variant="outlined">Outboarding Employé</Button>
                <Button variant="outlined">Commande de matériel</Button>
                <Button variant="outlined">Gestion de licences</Button>
                </Stack>
        </Box>
        <Box>
            <Typography variant="h6" my={4}>Vos demandes</Typography>
        </Box>

    </Box>
);
}
